module.exports = __webpack_public_path__ + "img/Breisgau.1fc2cd95.svg";